/**
 * Usercentrics template IDs for consent-gated services only.
 * Essential services (Sentry, Braze, Google Sign-In, Algolia) are always on — see
 * docs/usercentrics/USERCENTRICS_SETUP.md for disclosure IDs and categories.
 *
 * firebase (kjk3gPD2cxt_Ea): Google Firebase Analytics DPS — single gate for all
 * Firebase / GA4 collection in this app, including Google Consent Mode ad signals
 * used by the Firebase SDK (analytics_storage, ad_storage, ad_user_data, ad_personalization).
 *
 * metaPixel: Meta Pixel DPS (web). Separate from native Meta SDK (`1XvFW-Y2k` in novaheal-native).
 */
export const UC_SERVICES = {
  youtube: 'BJz7qNsdj-7',
  firebase: 'kjk3gPD2cxt_Ea',
  hotjar: 'S1kgcNo_j-m',
  metaPixel: 'ko1w5PpFl',
} as const;

export type UcServiceId = (typeof UC_SERVICES)[keyof typeof UC_SERVICES];

/** Hotjar site ID — previously inlined in public/index.html */
export const HOTJAR_SITE_ID = 3369880;

export const isMetaPixelConsentServiceConfigured = (): boolean => Boolean(UC_SERVICES.metaPixel);
